import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { AuthenticationService } from "app/_services/authentication.service";
import { PrivilegeEnum } from "@system-shared/enums";
import { UtilService } from "../../_services/util.service";

@Injectable({
  providedIn: 'root'
})
export class UserManagementGuard {
  user;

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private util: UtilService,
  ) {};

  async checkIfUserManagementAccess() {
    await this.authenticationService.userHasPrivilege(PrivilegeEnum.EDIT_USERS).subscribe((value) => {
      if (value) {
        return true;
      } else {
        this.router.navigateByUrl('/');
        return false;
      }
    }, (response) => {
      this.util.navigateExternal(response.error.url);
      return false;
    });
  }

  canActivate() {
    return this.checkIfUserManagementAccess();
  }

  canActivateChild() {
    return this.checkIfUserManagementAccess();
  }

  canLoad() {
    return this.checkIfUserManagementAccess();
  }
};
